import { ETipType, TTip } from '../interfaces';
import CarouselTip from './CarouselTip';
import TextTip from './TextTip';
import VideoTip from './VideoTip';

const renderTip = (tip: TTip, isInsideCarousel?: boolean) => {
  switch (tip.type) {
    case ETipType.TEXT:
      return <TextTip body={tip.body} isInsideCarousel={isInsideCarousel} />;
    case ETipType.VIDEO:
      return (
        <VideoTip
          video={tip.video}
          body={tip.body}
          title={tip.title}
          isInsideCarousel={isInsideCarousel}
        />
      );
    case ETipType.CAROUSEL:
      return <CarouselTip pages={tip.pages} />;
  }
};

export default renderTip;
